import { Mixpanel, MIXPANEL_EVENTS } from 'utils/mixpanel'

import { EVENTS } from './events'

export const MIXPANEL_NORMALIZED_EVENTS = {
  [EVENTS.PRICE_PAGE_VIEW]: Mixpanel.trackPricingPageView,
  [EVENTS.PURCHASE_CLICK]: Mixpanel.trackPurchaseClick,
  [EVENTS.SIGN_UP_PAGEVIEW]: Mixpanel.trackSignUpPageview,
  [EVENTS.SIGN_IN_PAGEVIEW]: Mixpanel.trackSignInPageView,
  [EVENTS.SIGN_IN_SUCCESS]: Mixpanel.trackSignInSuccess,
  [EVENTS.SIGN_UP_SUCCESS]: Mixpanel.trackSignUpSuccess,
  [EVENTS.PLAN_SELECT_CLICK]: Mixpanel.trackPlanSelectClick,
  [EVENTS.CHECKOUT_VIEW]: Mixpanel.trackCheckoutView,
  [EVENTS.NEW_CHECKOUT_MODAL_VIEW]: Mixpanel.trackNewCheckoutModalView,
  [EVENTS.PAYMENT_SELECT_CLICK]: Mixpanel.trackPaymentSelectClick,
  [EVENTS.PAYMENT_SUBMIT_CLICK]: Mixpanel.trackPaymentSubmitClick,
  [EVENTS.CHECKOUT_SUCCESS]: Mixpanel.trackCheckoutSuccess,
  [EVENTS.CHECKOUT_ERROR]: Mixpanel.trackCheckoutError,
  [EVENTS.ATP_CROSS_SELL_MODAL_CLICK]: Mixpanel.trackAtpCrossSellModalClick,
  [EVENTS.BUY_ADDON_CLICK]: Mixpanel.trackBuyAddonClick,
  [EVENTS.UNLOADED_REPORT_VIEW]: Mixpanel.trackUnloadedReportView,
  [EVENTS.LOADED_REPORT_VIEW]: Mixpanel.trackLoadedReportView,
  [EVENTS.PROJECT_CREATION_CLICK]: Mixpanel.trackProjectCreationClick,
  [EVENTS.PROJECT_CREATION_SUCCESS]: Mixpanel.trackProjectCreationSuccess,
  [EVENTS.CANCEL_SUBSCRIPTION_SUCCESS]: Mixpanel.trackCancelSubscriptionSuccess,
  [EVENTS.PROJECT_CREATION_SUCCESS_MODAL_CLICK]:
    Mixpanel.trackProjectCreationSuccessModalClick,
  [EVENTS.START_TRIAL]: Mixpanel.trackCheckoutSuccess,
  [EVENTS.PLAIN_FILTER_CLICK]: Mixpanel.trackPlainFilterClick,
  [EVENTS.COPY_SUCCESS]: Mixpanel.trackCopySuccess,
  [EVENTS.EXPORT_SUCCESS]: Mixpanel.trackExportSuccess,
  [EVENTS.CHANGE_EMAIL_CLICK]: () =>
    Mixpanel.trackChangeEmail(MIXPANEL_EVENTS.CHANGE_EMAIL_CLICK),
  [EVENTS.CHANGE_EMAIL_OLD_EMAIL_PASSWORD_WRONG]: () =>
    Mixpanel.trackChangeEmail(
      MIXPANEL_EVENTS.CHANGE_EMAIL_OLD_EMAIL_PASSWORD_WRONG,
    ),
  [EVENTS.CHANGE_EMAIL_SEND_CODE_TO_OLD_EMAIL]: () =>
    Mixpanel.trackChangeEmail(
      MIXPANEL_EVENTS.CHANGE_EMAIL_SEND_CODE_TO_OLD_EMAIL,
    ),
  [EVENTS.CHANGE_EMAIL_CONTACT_US_OLD_EMAIL]: () =>
    Mixpanel.trackChangeEmail(
      MIXPANEL_EVENTS.CHANGE_EMAIL_CONTACT_US_OLD_EMAIL,
    ),
  [EVENTS.CHANGE_EMAIL_OLD_EMAIL_VALIDATED]: () =>
    Mixpanel.trackChangeEmail(MIXPANEL_EVENTS.CHANGE_EMAIL_OLD_EMAIL_VALIDATED),
  [EVENTS.CHANGE_EMAIL_OLD_EMAIL_CODE_ERROR]: () =>
    Mixpanel.trackChangeEmail(
      MIXPANEL_EVENTS.CHANGE_EMAIL_OLD_EMAIL_CODE_ERROR,
    ),
  [EVENTS.CHANGE_EMAIL_RESEND_CODE_OLD_EMAIL]: () =>
    Mixpanel.trackChangeEmail(
      MIXPANEL_EVENTS.CHANGE_EMAIL_RESEND_CODE_OLD_EMAIL,
    ),
  [EVENTS.CHANGE_EMAIL_MAX_ATTEMPTS_EXCEEDED_OLD_EMAIL_USER_BLOCKED]: () =>
    Mixpanel.trackChangeEmail(
      MIXPANEL_EVENTS.CHANGE_EMAIL_MAX_ATTEMPTS_EXCEEDED_OLD_EMAIL_USER_BLOCKED,
    ),
  [EVENTS.CHANGE_EMAIL_MAX_ATTEMPTS_EXCEEDED_OLD_EMAIL_CONTACT_SUPPORT]: () =>
    Mixpanel.trackChangeEmail(
      MIXPANEL_EVENTS.CHANGE_EMAIL_MAX_ATTEMPTS_EXCEEDED_OLD_EMAIL_CONTACT_SUPPORT,
    ),
  [EVENTS.CHANGE_EMAIL_OLD_EMAIL_CODE_VALIDATED]: () =>
    Mixpanel.trackChangeEmail(
      MIXPANEL_EVENTS.CHANGE_EMAIL_OLD_EMAIL_CODE_VALIDATED,
    ),
  [EVENTS.CHANGE_EMAIL_SEND_CODE_TO_NEW_EMAIL]: () =>
    Mixpanel.trackChangeEmail(
      MIXPANEL_EVENTS.CHANGE_EMAIL_SEND_CODE_TO_NEW_EMAIL,
    ),
  [EVENTS.CHANGE_EMAIL_NEW_EMAIL_CODE_ERROR]: () =>
    Mixpanel.trackChangeEmail(
      MIXPANEL_EVENTS.CHANGE_EMAIL_NEW_EMAIL_CODE_ERROR,
    ),
  [EVENTS.CHANGE_EMAIL_RESEND_CODE_NEW_EMAIL]: () =>
    Mixpanel.trackChangeEmail(
      MIXPANEL_EVENTS.CHANGE_EMAIL_RESEND_CODE_NEW_EMAIL,
    ),
  [EVENTS.CHANGE_EMAIL_MAX_ATTEMPTS_EXCEEDED_NEW_EMAIL_USER_BLOCKED]: () =>
    Mixpanel.trackChangeEmail(
      MIXPANEL_EVENTS.CHANGE_EMAIL_MAX_ATTEMPTS_EXCEEDED_NEW_EMAIL_USER_BLOCKED,
    ),
  [EVENTS.CHANGE_EMAIL_MAX_ATTEMPTS_EXCEEDED_NEW_EMAIL_CONTACT_SUPPORT]: () =>
    Mixpanel.trackChangeEmail(
      MIXPANEL_EVENTS.CHANGE_EMAIL_MAX_ATTEMPTS_EXCEEDED_NEW_EMAIL_CONTACT_SUPPORT,
    ),
  [EVENTS.CHANGE_EMAIL_NEW_EMAIL_UPDATED]: () =>
    Mixpanel.trackChangeEmail(MIXPANEL_EVENTS.CHANGE_EMAIL_NEW_EMAIL_UPDATED),
  [EVENTS.CHANGE_EMAIL_CLICK_ALERT_CONFIRM_EMAIL]: () =>
    Mixpanel.trackChangeEmail(
      MIXPANEL_EVENTS.CHANGE_EMAIL_CLICK_ALERT_CONFIRM_EMAIL,
    ),
  [EVENTS.CHANGE_EMAIL_CLICK_BANNER_CONFIRM_EMAIL]: () =>
    Mixpanel.trackChangeEmail(
      MIXPANEL_EVENTS.CHANGE_EMAIL_CLICK_BANNER_CONFIRM_EMAIL,
    ),
  [EVENTS.CHANGE_EMAIL_NOTIFICATION_CONFIRM_NEW_EMAIL]: () =>
    Mixpanel.trackChangeEmail(
      MIXPANEL_EVENTS.CHANGE_EMAIL_NOTIFICATION_CONFIRM_NEW_EMAIL,
    ),
  [EVENTS.CHOOSE_YOUR_SUCCESS_PATH_VIEW]:
    Mixpanel.trackChooseYourSuccessPathView,
  [EVENTS.CHOOSE_YOUR_SUCCESS_PATH_CTA_CLICKED]:
    Mixpanel.trackChooseYourSuccessPathCTAClicked,
  [EVENTS.UPLOAD_CSV_SUCCESS]: Mixpanel.trackUploadCSVSuccess,
} as const
